module.exports = __webpack_public_path__ + "static/media/perpara108.426ba84a.jpg";